import { useContext, useMemo } from 'react';
import css from './store-search-item.module.scss';
import UserContext from '../../../../../common/utils/getContext';
import { Img, svgSprite } from '../../../../../hybrid/wrappers';
import classNames from 'classnames';

const StoreSearchItem = ({ item }) => {
    const { lang, userToken } = useContext(UserContext);
    const item_type = useMemo(() => item?.properties?.find((prop) => prop?.name === 'gtshop::type')?.value, [item]);
    return (
        <div
            className={css.storeSearchItem}
            onClick={() => {
                window.location.href = `/${lang}/store/product/${item.id}`;
            }}
        >
            <div className={classNames(css.storeSearchImg, { [css.storeSearchImgNo]: !item?.image?.links?.preview })}>
                {item?.image?.links?.preview ? (
                    <Img src={item?.image?.links?.preview} alt={`${item.name} image`} />
                ) : (
                    svgSprite('product-no-image')
                )}
            </div>
            <div className={css.storeSearchInfo}>
                {item_type ? <p className={css.storeSearchType}>{item_type}</p> : null}
                <p className={css.storeSearchName}>{item.name}</p>
                <div>
                    <p className={css.storeSearchPrice}>{item.price?.price_for_currency_formatted}</p>
                    {userToken ? (
                        <p className={css.storeSearchMarketingPrice}>{item?.price?.price_for_client_formatted}</p>
                    ) : null}
                </div>
            </div>
        </div>
    );
};
export default StoreSearchItem;
